// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/og-var.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

@font-face {
    font-family: "Overused Grotesk";
    font-style: normal;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

.font-og {
    font-family: "Overused Grotesk";
}

.accordion-content {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
}

.accordion-content.active {
    overflow: visible;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s;
    z-index: 99;
}

.modal-background {
    position: absolute;
    inset: 0;
    z-index: 10;
}

.modal-content {
    position: relative;
    z-index: 11;
    background: white;
    transform: translateY(50px);
    opacity: 0;
    transition: all 0.3s;
}

.modal-overlay.show .modal-content {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
}

.modal-overlay.show {
    opacity: 1;
    pointer-events: auto;
}

.flipSvg > div > svg {
    transform: rotate(180deg);
    transition-duration: 400ms;
}
`, "",{"version":3,"sources":["webpack://./src/components/assets/css/input.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,+DAAkD;AACtD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,UAAU;IACV,oBAAoB;IACpB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@font-face {\n    font-family: \"Overused Grotesk\";\n    font-style: normal;\n    font-display: swap;\n    src: url(\"../fonts/og-var.ttf\") format(\"truetype\");\n}\n\n.font-og {\n    font-family: \"Overused Grotesk\";\n}\n\n.accordion-content {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n}\n\n.accordion-content.active {\n    overflow: visible;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.5);\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.3s;\n    z-index: 99;\n}\n\n.modal-background {\n    position: absolute;\n    inset: 0;\n    z-index: 10;\n}\n\n.modal-content {\n    position: relative;\n    z-index: 11;\n    background: white;\n    transform: translateY(50px);\n    opacity: 0;\n    transition: all 0.3s;\n}\n\n.modal-overlay.show .modal-content {\n    transform: translateY(0);\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.modal-overlay.show {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.flipSvg > div > svg {\n    transform: rotate(180deg);\n    transition-duration: 400ms;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
